import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { useState } from 'react';

/**
 * Megerősítő párbeszéd kötelező indoklással.
 *
 * A spec 17.1 §-a veszélyes műveleteknél összesítő és megerősítő képernyőt
 * ír elő; az indoklás pedig az eseménynaplóba kerül, tehát később
 * megválaszolható, hogy MIÉRT nyomtattunk újra vagy selejteztünk.
 */
export function ReasonDialog({
  open,
  title,
  description,
  confirmLabel,
  destructive,
  pending,
  onClose,
  onSubmit,
}: {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  destructive?: boolean;
  pending: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
}) {
  const [reason, setReason] = useState('');

  const close = () => {
    setReason('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Alert severity={destructive ? 'warning' : 'info'}>{description}</Alert>
          <TextField
            label="Indoklás"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            helperText="Az eseménynaplóba kerül."
            autoFocus
            required
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Mégse</Button>
        <Button
          variant="contained"
          color={destructive ? 'error' : 'primary'}
          disabled={reason.trim().length === 0 || pending}
          onClick={() => onSubmit(reason.trim())}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
